export default __webpack_public_path__ + "static/27-9b6f0f186b676908a88edad438250d4c.gif";